import styled from "styled-components";

export const DateTimerPickerWrapper = styled.section`
  font-weight: 400;
  font-size: 13px;
  color: #444444;

  p {
    margin-bottom: 10px;
  }

  .react-datepicker__current-month {
    text-transform: capitalize;
  }

  .react-datepicker__input-container {
    input {
      width: 100%;
      border: 1px solid #ebebeb;
      border-radius: 2px;
      text-align: left;
      line-height: 1;
      color: #1e1e1e;
      background-color: white;
      font-size: 11px;
      padding: 10px;
      color: #1e1e1e;
      &:focus-visible {
        outline: none;
      }
    }
    img {
      display: none;
      width: 10px;
    }
    &:hover {
      input {
        background-color: rgba(68, 173, 248, 0.1);
        box-shadow: 0px 0px 0px 3px white inset;
        cursor: pointer;
      }
      img {
        display: block;
      }
    }
  }

  .react-datepicker {
    border: 1px solid #ebebeb;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 10%), 0 4px 11px rgb(0 0 0 / 10%);
    .react-datepicker__triangle {
      display: none;
    }
  }

  .react-datepicker__header {
    background-color: #f9f9f9;
    padding: 12px 0;
    border-bottom: 2px solid #ebebeb;

    .react-datepicker__day-names {
      padding: 7px 0;
      margin-bottom: -13px;
    }
    .react-datepicker__current-month,
    .react-datepicker-time__header {
      font-weight: 500;
      color: #4d4d4d;
    }

    .react-datepicker-time__header {
      display: flex;
      flex-direction: column;

      #timezoneLabel {
        font-weight: 400;
        font-size: 10px;
        margin-bottom: 0;
        color: #898989;
      }

      #hourLabel {
        margin-bottom: 4px;
      }
    }
  }
  .react-datepicker__header--time {
    padding: 7px 0px;
  }

  .react-datepicker__time-list-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .react-datepicker__day--selected,
  .react-datepicker__time-list-item--selected,
  .react-datepicker__day--keyboard-selected {
    background-color: #50aff4 !important;
    &:hover {
      background-color: #3d9ee4 !important;
    }
  }

  .react-datepicker__time-container {
    border-left: 1px solid #ebebeb;
  }
`;
